<template>
    <div class="pt-3 px-2" v-if="refresh" data-cy="container_profile_address_delivery_form_main">
        <InputText
                v-model:inputValue="addressModel.addressName"
                :errorInfo="errorInfo[0]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.addressName"
                data-cy="input_profile_address_delivery_address_name"
        ></InputText>
        <InputText
                v-model:inputValue="addressModel.firstname"
                :errorInfo="errorInfo[1]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.firstname"
                data-cy="input_profile_address_delivery_firstname"
        ></InputText>
        <InputText
                v-model:inputValue="addressModel.lastname"
                :errorInfo="errorInfo[2]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.lastname"
                data-cy="input_profile_address_delivery_lastname"
        ></InputText>
        <InputContactNumber
                v-model:inputValue="addressModel.contactNumber"
                :minLength="10"
                :maxLength="12"
                delimeter="-"
                :errorInfo="errorInfo[3]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.contactnumber"
                data-cy="input_profile_address_delivery_contact_number"
        ></InputContactNumber>
        <InputText
                v-model:inputValue="addressModel.address"
                :errorInfo="errorInfo[4]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.address"
                data-cy="input_profile_address_delivery_address"
        ></InputText>
        <FormAddressDropdown
                v-model:inputValue="formAddressModel"
                :errorInfo="errorInfo[5]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping"
                data-cy="container_profile_address_delivery_dropdown"
        ></FormAddressDropdown>
        <Checkbox
                v-model:check="addressModel.isDefault"
                :text="lbl.shipping.isDefaultAddress"
                data-cy="checkbox_profile_address_delivery_default"
        ></Checkbox>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import { FormHelper } from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/label/InputText.vue";
import InputContactNumber from "@/components/Input/label/InputContactNumber.vue";
import Checkbox from "@/components/Input/simple/Checkbox.vue";
import FormAddressDropdown from "@/components/Form/FormAddressDropdown.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";

export default {
    name: "FormDeliveryAddress",
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputContactNumber,
        Checkbox,
        FormAddressDropdown,
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formAddressModel: null,
            addressModel: null,
        };
    },
    created: function() {
        this.initForm(null);
        this.errorInfo = FormHelper.genErrorInfo(6);
    },
    methods: {
        initForm: function(address) {
            this.isSubmitted = false;

            if (address != null) {
                this.addressModel = {...address};
                this.formAddressModel.setValueFromAddressListModel(this.addressModel);
            } else {
                this.addressModel = new AddressListModel();
                this.formAddressModel = new AddressModel();
            }

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.addressModel;
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
